import { useCallback, useEffect, useRef, useState } from 'react';
import { MSG_TYPE_CONFIRM_DELETE_COMMENT, MSG_TYPE_OPENED_MINI_COMMENTER, MSG_TYPE_REMOVE_EMBEDDED_COMMENT } from '../../../constants/IFrameMessageTypes';
export default function useEmbeddedCommentsMessaging({
  moduleId,
  broadcastCommentsMessage,
  collaborationSidebarState,
  onClose,
  isOpen
}) {
  const [isMessageHandlerReady, setIsMessageHandlerReady] = useState(false);
  const sendMessageRef = useRef(undefined);

  // Broadcast a message to preload the collaboration sidebar
  // as we use it for controlling the delete comment modal.
  useEffect(() => {
    if (isOpen) {
      broadcastCommentsMessage({
        type: MSG_TYPE_OPENED_MINI_COMMENTER
      });
    }
  }, [broadcastCommentsMessage, isOpen]);
  const handleBroadcastMessagesFromSidebar = useCallback(message => {
    if (message.type === MSG_TYPE_REMOVE_EMBEDDED_COMMENT && message.payload.moduleId === moduleId && onClose) {
      onClose();
    }
  }, [onClose, moduleId]);

  // Relay a broadcast message
  useEffect(() => {
    if (collaborationSidebarState.broadcastCommentMessage && sendMessageRef.current) {
      const message = collaborationSidebarState.broadcastCommentMessage;
      handleBroadcastMessagesFromSidebar(message);
      sendMessageRef.current(message.type, message);
    }
  }, [collaborationSidebarState.broadcastCommentMessage, handleBroadcastMessagesFromSidebar, isMessageHandlerReady]);

  // TODO: Delete once MSG_TYPE_CONFIRM_DELETE_COMMENT has been converted to a broadcast message
  const broadcastDelete = useCallback(({
    payload
  }) => {
    var _payload;
    if (payload.type === MSG_TYPE_CONFIRM_DELETE_COMMENT &&
    // Forwards compatibility check while converting this message to a broadcast message
    !('broadcast' in payload) && !((_payload = payload.payload) !== null && _payload !== void 0 && _payload.broadcast) && collaborationSidebarState.broadcastCommentMessage) {
      broadcastCommentsMessage(payload);
    }
  }, [broadcastCommentsMessage, collaborationSidebarState.broadcastCommentMessage]);
  const handleReady = useCallback(({
    sendMessage
  }) => {
    sendMessageRef.current = sendMessage;
    setIsMessageHandlerReady(true);
  }, [sendMessageRef]);
  return {
    handleReady,
    broadcastDelete
  };
}